import { render } from "./Register.vue?vue&type=template&id=1e1e8f7a"
import script from "./Register.vue?vue&type=script&scoped=true&lang=js"
export * from "./Register.vue?vue&type=script&scoped=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__